<div class="execution-wrapper">
  <div id='rootExecution' class="container-tool">
    <h1>Portfolio configuration</h1>
    <p class="description">Configure all your portfolios, defining ramo and earned premium for each one. Portfolio aggregations can also be created and configured. 
      Please note that configurations set now cannot be changed later.
    </p>
    <app-input-uploader
        [title]='"Add file"' 
        [id]='idExecution'
        [selector]='template-portfolios-association'
        (sendInfoToParent)='getFileFromInput($event, portfolioAssociationTemplate )'>
    </app-input-uploader>

    <div class="title-info gutter-top-56">
      <p class="title">Your portfolios</p>
      <a class="create-aggregation" (click)="openModal()">Create aggregation</a>
    </div>
    <div class="portfolio-container" *ngFor='let portfolio of portfolios'>
      <app-portfolio-info
        [title]='portfolio.name' 
        [portfolio]='portfolio'
        (sendPortfolioIdToParent)='getPortfolioId(portfolio.id)' 
        (sendInvalidSelectToParent)='getInvalidSelection()'
        (sendAttributeInfoToParent)='getAttributeInfo(portfolio.id)'>
      </app-portfolio-info>
    </div>
  </div>
  <app-execution-sidebar
    [execution]="execution"
    isDescriptionPresent
    [isContinueAvailable]='isContinueBtnAvailable'
    (continue)='continue()'
  ></app-execution-sidebar>
</div>
